import React from "react"
import { graphql } from "gatsby"
import styled from "styled-components"
import Grid from "@material-ui/core/Grid"

import Section from "../components/Section"
import SEO from "../components/seo"
import breakpoints from "../styles/breakpoints"
import {
  GreyBackground,
  GreyRequirements,
  SmallTitle,
} from "../styles/sharedStyles"
import VacancyDetails from "../components/VacancyDetails"
import ShowDesktopOnly from "../components/ShowDesktopOnly"
import LetsConnect from "../components/LetsConnect"
import ShowMobileOnly from "../components/ShowMobileOnly"
import SvgBorderTop from "../components/SvgBorderTop"
import StorySelection from "../components/StorySelection"
import VacancySelection from "../components/VacancySelection"
import SocialShare from "../components/SocialShare"
import ApplyNowDrawer from "../components/ApplyNowDrawer"
import ContentWithNav from "../components/ContentWithNav"
import HeroFullWidthMiddle from "../components/HeroFullWidthMiddle"
import Vspacer from "../components/Vspacer"
import vSpacing from "../styles/vSpacing"
import FaqCategory from "../components/FaqCategory"
import BreadCrumbs from "../components/BreadCrumbs"
import { Container } from "../components/Container"

import localeData from "../locale"

import Typography from "../components/Typography"
import BlockText from "../components/BlockText"

import { currentLocale } from "../locale/languages"
import slugify from "../utils/slugify"

const { H300Semibold } = Typography

const VacancyContainer = styled.div`
  background-color: transparent;
  background: url("data:image/svg+xml,%3csvg viewBox='0 0 680 975' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cdefs%3e%3cpath id='a' d='M0 0h680v975H0z'/%3e%3c/defs%3e%3cg fill='none' fill-rule='evenodd'%3e%3cmask id='b' fill='white'%3e%3cuse xlink:href='%23a'/%3e%3c/mask%3e%3cpath d='M-717.1722-140.15v-.002c.393-.305.765-.614 1.129-.925.485-.413.951-.832 1.375-1.259 4.782-4.781 5.331-29.87 5.357-43.918.006-3.582-.021-6.457-.021-8.082 0-7.824-5.091-34.117-5.312-46.494-.008-.272-.02-.58-.02-.836 0-8.436 25.864-70.072 52.324-105.336 3.996-5.324 24.536-7.336 27.584-11.332 5.48-7.184 9.1-11.804 9.672-12.376.488-.484 2.5-2.144 5.52-4.58h.002c5.92-4.78 14.648-20.188 28.1-27.712 22.104-12.356 50.54-17.076 52.796-19.332 4.336-4.332 3.336-24.668 3.336-28 0-3.332 22-28.668 28-34.668s33.332-12 40-18.664c6.664-6.668 17.164-30.836 17.164-30.836 1.284-1.284 8.152-14.436 12.168-12.164 1.728.98-.024 16.664 1.9 17.828 5.768 3.492 11.988 7.172 16.1 7.172 8.668 0 16.668-8.668 25.332-8.668 8.668 0 15.336 16 22.668 16 .948 0 2.168-.268 3.584-.744h.002c9.52-3.184 28.488-16.144 42.412-26.588 16-12 32.668 0 60-8 27.336-8 67.336 6 76 6 3.164 0 4.548-2.052 5.716-4.648 2.028-4.512 3.396-10.688 12.284-10.688 4.348 0 8.216 1.704 11.628 4.204 3.152 2.308-5.364 7.516-2.96 10.464 3.376 4.14 23.988-7.512 26-5.5 1.632 1.632-8.192 9.084-8.5 14.84-.296 5.528 8.852 11.524 10 17.036 1.32 6.332-5.396 12.024-6.832 15.624-4 10 9.664 26.332 15.332 32 5.668 5.668 52.668 11.332 55.332 20 2.668 8.668 22.668 16.668 35.336 18 12.664 1.332 19.332 14 34.664 18.668 15.336 4.664 34.752-1.416 34.752-10.084s-13.328-35.34-9.084-39.584c5.748-5.752 38.052-8.96 47.5-7 11.285 2.34 17.036 19.332 26.832 19.332 6.104 0 14.224 1.24 23.556 2.992l.002-.002c18.196 3.412 41.072 8.808 63.108 11.012 33.336 3.332 36.668-4.668 53.336-10 16.664-5.332 28.664 33.332 40.664 53.332s60.668 86 68 108c1.764 5.287 3.568 9.595 5.472 13.303v-.001c3.763 7.318 7.927 12.221 12.993 17.343 3.04 3.073 6.405 6.225 10.203 10.023 13.332 13.332 26.332 77.668 38 89.332l-.001.001.001.001c11.668 11.664 38.668 37.332 42 54 3.077 15.368 31.644 29.052 51.76 46.772 1.696 1.492 3.353 3.004 4.908 4.56 2.296 2.3 4.325 4.716 6.172 7.184-.155.3-.325.602-.505.905.18-.302.35-.604.505-.903 6.036 8.08 9.872 16.784 12.861 24.392v-.001s3.299 14.756 18.299 17.756c9.489 1.896 15.668-2 37.668-.332 22 1.664 24-8.668 38.332-8.668s58.832-24.5 62.668-28.332c3.832-3.836 14.296-5.924 16.332-4.816 2.036 1.112-7 48.148-10.168 51.316-3.164 3.164-8.5 5.5-8.5 10.164 0 4.668-3.511 30.792-15.511 53.792s-2.569 27.116-8.489 33.036c-5.916 5.92-21 7.172-27 18.508-6 11.332-2.664 16.332-9.332 23-6.668 6.664-26.364 30.36-47.532 51.528-21.164 21.164-34.136 18.804-44.8 29.472-10.668 10.668-33.343 36.988-39.044 41.389-6.927 7.62-18.2 7.967-26.156 11.112-8.863 3.5-1.636 15-4.136 22-1.255 3.512-7.175 15.224-13.139 27.092h-.001c-5.912 11.762-11.864 23.674-13.36 27.906-.071.203-.118.407-.164.611-1.064 5.444 9.853 8.884 15.504 14.061 2.72 2.488 15.296-.9 15.296 1.16l-22.136 42.168c0 .656.066 1.393.19 2.2 1.855 12.101 16.828 39.814 20.81 43.8 4.252 4.252-4.5 36.5-8.5 47.5s8.5 26.5 8.5 41.5-26 31-63 56-64.5 40.5-71 53.5 4.5 22.5 7.5 39.5 2.5 47 0 54-50.248 22.252-54 26c-3.748 3.752-8.5 21.5 0 24 2.105.62 2.98 2.348 3.064 4.752.257 7.296-6.808 20.848-9.064 28.748-3 10.5-9.5 12.5-21.5 18.5s-62.928 73.572-76.364 87c-13.428 13.432-65.636 14.5-89.96 14.5-24.324 0-38.676 7.5-48.176 10.5s-15.5 6-26.472 0c-10.968-6-18.304-22.72-22.588-27-4.28-4.28 4.196-4 4.196-6.5s2.024-23.156-7.32-32.5c-9.34-9.344-12.816-33-20.316-49-1.268-2.712-2.804-5.432-4.432-8.164.008-.008.02-.012.028-.02v-.001c-.008.008-.02.013-.028.021-7.984-13.401-19.336-26.96-25.568-39.836-7.5-15.5-13-73-13-82.5s-5-19.5-18-45-34.5-41.5-40-52.5c-2.688-5.38-4.651-12.788-5.496-20.008-.884-7.552-.548-14.892 1.496-19.492 4-9 13.5-55.5 13.5-64.5s19.5-6 24-30-7.248-46.752-12.5-52c-5.248-5.252 6-8.5 6-19.5s-24.5-41-29.5-46c-.516-.52-.904-1.152-1.228-1.856-2.468-5.388-.088-16.132-6.124-31.988-.752-1.98-1.6-4.016-2.648-6.156-2.3-4.712-5.496-9.892-9.152-15.208-.946-1.377-1.928-2.764-2.933-4.155v.001c-3.571-4.946-7.472-9.948-11.409-14.768-.057-.07-.115-.142-.173-.212-.358-.438-.716-.874-1.075-1.308-.111-.134-.221-.268-.331-.402-.32-.387-.64-.771-.959-1.155-.153-.184-.306-.367-.459-.55-.282-.337-.563-.673-.845-1.008-.194-.231-.389-.463-.583-.692-.247-.293-.493-.584-.739-.874-.24-.283-.479-.565-.719-.846-.199-.233-.399-.468-.597-.7-.295-.344-.588-.686-.881-1.026-.148-.173-.297-.346-.445-.518-.392-.454-.782-.904-1.169-1.351l-.132-.152c-6.921-7.96-13.217-14.711-17.147-18.824-6.246-6.536-8.941-13.744-8.638-20.11.218-4.593 1.993-8.749 5.137-11.892 2.324-2.322 3.473-5.221 3.869-8.517.395-3.3.029-7.003-.722-10.95-.371-1.949-.831-3.955-1.339-6.002h.001v-.001h-.002c-.752-3.028-1.596-6.144-2.388-9.28-2.052-8.104 4.248-14.776 9.816-20.624 3.936-4.132 7.516-7.856 7.516-11.376 0-4.644-13.16-9.708-20.752-18.488-6.3-7.284-6.444-18.672-13.248-20.464-1.791-.472-4.01-.78-6.512-.976-.001.001-.001 0-.001.002-2.792-.221-6.091-.295-9.691-.286-10.483.049-22.97.892-32.865.779-10.725.074-19.568-.485-22.104-3.021-2.464-2.461 1.107-6.649-.772-11.173-.004-.009-.009-.02-.013-.029-1.905-4.584-3.587-9.505-5.193-13.343-.072-.172-.145-.345-.216-.513-.074-.173-.147-.34-.221-.507-.089-.202-.178-.4-.266-.594-.063-.138-.125-.275-.188-.409-.123-.262-.246-.515-.368-.761-.029-.058-.058-.12-.087-.177-.155-.305-.309-.593-.464-.867-.034-.062-.068-.117-.102-.177-.123-.213-.247-.418-.37-.61-.041-.064-.081-.126-.122-.188-.125-.188-.25-.364-.376-.528-.031-.042-.063-.086-.094-.126-.159-.2-.317-.383-.477-.543-.925-.926-3.113-2.161-6.134-3.479-9.224-4.02-26.24-8.816-39.06-7.99 0-.001.002-.002.002-.003h-.002c-.001.001-.001.002-.002.003-2.248.144-4.38.444-6.3.968-5.652 1.54-9.228 3.848-12.016 6.392h-.002c-2.1 1.914-3.748 3.961-5.468 5.923-1.911 2.18-3.92 4.25-6.736 5.911-.79.467-1.644.9-2.578 1.295-.384.168-.782.329-1.201.48-.116.041-.241.082-.362.123-.446.153-.911.306-1.355.46-2.371.815-4.914 1.619-7.576 2.428-4.327 1.315-8.974 2.647-13.739 4.073-4.403 1.317-8.902 2.721-13.34 4.262-3.265 1.134-6.497 2.34-9.628 3.654-.61.256-1.215.468-1.819.661-.043.014-.087.026-.13.04-14.674 4.588-27.283-8.701-32.551-8.701-.534 0-1.448-.071-2.644-.191-.747-.073-1.603-.166-2.549-.272-13.148-1.484-38.488-.472-52.808 2.9-17 4-12.5 6.06-23 9.06-5.556 1.588-13.948 3.96-21.272 5.208h-.002c-6.516 1.108-12.188 1.336-14.228-.704-3.496-3.5-19.595-21.756-33.383-28.668h.015c-3.298-1.655-6.466-2.668-9.296-2.668-11.172 0-18.864-10.82-27.788-18.928l-.001.002c-2.792-2.54-5.7-4.82-8.88-6.408-11.856-5.924-22.632-29.732-24.88-38.228l-.003-.002c-.28-1.056-.448-1.92-.448-2.436 0-4.668-3.336-22.908-10-22.908-6.668 0-14-25.092-14-31.76 0-.229-.045-.47-.118-.718-.003.001-.007.002-.011.003-1.121-3.852-10.65-10.013-19.009-16.279-.003-.003-.007-.006-.011-.008-1.27-.953-2.513-1.907-3.695-2.857v-.001c-5.156-4.144-14.158-13.179-14.158-16.474 0-9.332 1.668-55.664 1.668-64.332 0-7.592 9.716-12.112 16.16-17.148zM656.6663 504.6659c3.748 3.748 7 27 9.5 39.5s5 29 0 29-12.5-18-12.5-9-7.5 23-14.5 30-.5 36-9.5 50.5-46.5 129.5-56 129.5-30.748 24.252-38.5 16.5c-7.752-7.748-17.5-17-21.5-21.5s5-40 5-43.5-4-16-4-23 26-29.5 29-44.5-14.248-37.752-8-44c6.252-6.252 8.752-20.752 14.5-26.5 5.752-5.752 25.5-9 42-13.5s5-10.5 13-13 14.5-3.5 17-6 2.5-24 12-28.5 10.5-2 13.5-11 5.252-14.748 9-11z' fill='%23F6F6F4' mask='url(%23b)'/%3e%3c/g%3e%3c/svg%3e")
    top left;
  background-repeat: no-repeat;
  background-size: 40%;
  padding-top: 64px;
  ${breakpoints.md`
    padding-top: 136px;
  `};
`

const ProjectDetailsGridContainer = styled(Grid)`
  && {
    flex-direction: column-reverse;
    ${breakpoints.md`
      flex-direction: initial;
    `};
  }
`

const Title1 = styled.h1`
  margin: 16px 0 24px 0;
  color: ${(props) => props.theme.primaryColors.primary};
`
const Title2 = styled.h2`
  color: ${(props) => props.theme.primaryColors.primary};
  margin-bottom: ${vSpacing.baseX3};

  ${breakpoints.md`
    margin-bottom: ${vSpacing.baseX7};
  `}
`

const Title4 = styled.h2`
  text-align: center;
  color: ${(props) => props.theme.primaryColors.primary};
`

const Share = styled.strong`
  margin-top: 32px;
  ${breakpoints.md`
    margin-top: 0;
    margin-right: 14px;
  `};
`

export const vacancyQuery = graphql`
  query VacancyTemplateQuery($id: String!) {
    vacancy: sanityVacancy(id: { eq: $id }) {
      id
      _rawLocaleTitle
      vacancyTypes {
        _rawLocaleTitle
      }
      vacancyCountry {
        _rawLocaleTitle
        flag {
          asset {
            url
          }
        }
      }
      vacancyCategory {
        id
        _rawLocaleTitle
        categoryIcon {
          asset {
            url
          }
        }
      }
      vacancyMinimumLengthOfStay {
        id
        _rawLocaleTitle
      }
      _rawLocaleShortDescription
      _rawProjectDescription
      _rawProjectTheVacancy
      _rawProjectFacilities
      _rawProjectCosts
      _rawRequirements
      _rawSpecialRequirements
      faqCategory {
        _rawFaqs
      }
      _rawStartingPeriod
      _rawNumberOfPersons
      vacancyStudyFields {
        _rawLocaleTitle
      }
      teamMember {
        name
        degree
        phone
        email
        image {
          asset {
            url
          }
        }
      }
      image {
        asset {
          gatsbyImageData(width: 1600, fit: FILLMAX, placeholder: BLURRED)
        }
      }
    }
    sanityAllVacanciesPage {
      id
      _rawLocaleTitle
    }
  }
`

const VacancyPage = ({ data, pageContext }) => {
  const { locale } = pageContext
  const {
    _rawLocaleTitle,
    vacancyCountry,
    vacancyTypes,
    vacancyCategory,
    vacancyMinimumLengthOfStay,
    _rawStartingPeriod,
    _rawNumberOfPersons,
    vacancyStudyFields,
    _rawLocaleShortDescription,
    _rawProjectDescription,
    _rawProjectTheVacancy,
    _rawProjectFacilities,
    _rawProjectCosts,
    _rawRequirements,
    _rawSpecialRequirements,
    faqCategory,
    teamMember,
    image,
  } = data.vacancy

  const setLocaleInUrl = currentLocale !== locale ? `${locale}/` : ""

  const studyFields =
    vacancyStudyFields &&
    vacancyStudyFields.length &&
    vacancyStudyFields
      .map((type) => type && type._rawLocaleTitle && type._rawLocaleTitle[locale])
      .join(", ")

  const contentWithNavData = [
    {
      key:
        _rawProjectDescription &&
        _rawProjectDescription[locale] &&
        _rawProjectDescription[locale][0]._key,
      nav: localeData._rawProjectDescription,
      body: _rawProjectDescription && _rawProjectDescription,
    },
    {
      key:
        _rawProjectTheVacancy &&
        _rawProjectTheVacancy[locale] &&
        _rawProjectTheVacancy[locale][0]._key,
      nav: localeData._rawTheVacancy,
      body: _rawProjectTheVacancy && _rawProjectTheVacancy,
    },
    {
      key:
        _rawProjectFacilities &&
        _rawProjectFacilities[locale] &&
        _rawProjectFacilities[locale][0]._key,
      nav: localeData._rawFacilities,
      body: _rawProjectFacilities && _rawProjectFacilities,
    },
    {
      key:
        _rawProjectCosts &&
        _rawProjectCosts[locale] &&
        _rawProjectCosts[locale][0]._key,
      nav: localeData._rawCosts,
      body: _rawProjectCosts && _rawProjectCosts,
    },
  ]

  return (
    <>
      <SEO title={_rawLocaleTitle[locale]} />
      {_rawLocaleTitle && (
        <BreadCrumbs
          pageTitle={_rawLocaleTitle[locale]}
          parentTitle={data.sanityAllVacanciesPage._rawLocaleTitle[locale]}
          locale={locale}
          path={`/${setLocaleInUrl}${slugify(
            data.sanityAllVacanciesPage._rawLocaleTitle[locale]
          )}`}
        />
      )}
      <VacancyContainer>
        <Section paddingBottom>
          <ProjectDetailsGridContainer container spacing={0} justify="center">
            <Grid item xs={12} md={2}>
              <VacancyDetails
                flag={vacancyCountry && vacancyCountry.flag}
                country={
                  vacancyCountry && vacancyCountry._rawLocaleTitle[locale]
                }
                category={vacancyCategory}
                startingPeriod={
                  _rawStartingPeriod && _rawStartingPeriod[locale]
                }
                vacancyMinimumLengthOfStay={vacancyMinimumLengthOfStay}
                numberOfPersons={
                  _rawNumberOfPersons && _rawNumberOfPersons[locale]
                }
                studyFields={studyFields}
                locale={locale}
              />
            </Grid>
            <Grid item xs={false} md={1} />
            <Grid item xs={12} md={7}>
              {vacancyTypes && (
                <SmallTitle>
                  {vacancyTypes
                    .map((type) => type._rawLocaleTitle[locale])
                    .join(", ")}
                </SmallTitle>
              )}
              {_rawLocaleTitle && <Title1>{_rawLocaleTitle[locale]}</Title1>}
              <Vspacer marginBottom={vSpacing.baseX7}>
                {_rawLocaleShortDescription && (
                  <BlockText blocks={_rawLocaleShortDescription[locale]} />
                )}
              </Vspacer>
              <ShowDesktopOnly>
                <Grid container alignItems="center">
                  {_rawLocaleTitle && (
                    <Grid item md={4}>
                      <ApplyNowDrawer
                        locale={locale}
                        btn="Primary"
                        selectedVacancy={_rawLocaleTitle[locale]}
                      />
                    </Grid>
                  )}

                  <Grid item md={8} container alignItems="center">
                    <Share>{localeData._rawSocialButton[locale]}</Share>
                    <SocialShare
                      url={`/${setLocaleInUrl}${slugify(
                        _rawLocaleTitle[locale]
                      )}`}
                      text={vacancyTypes
                        .map((type) => type._rawLocaleTitle[locale])
                        .join(", ")}
                      longtext={_rawLocaleTitle[locale]}
                    />
                  </Grid>
                </Grid>
              </ShowDesktopOnly>
            </Grid>
          </ProjectDetailsGridContainer>
          <ShowMobileOnly>
            <Grid container alignItems="center">
              {_rawLocaleTitle && (
                <Grid item xs={12}>
                  <ApplyNowDrawer
                    locale={locale}
                    btn="Primary"
                    selectedVacancy={_rawLocaleTitle[locale]}
                  />
                </Grid>
              )}

              <Grid item xs={12} container direction="column">
                <Share>{localeData._rawSocialButton[locale]}</Share>
                <SocialShare
                  url={`/${setLocaleInUrl}${slugify(_rawLocaleTitle[locale])}`}
                  text={vacancyTypes
                    .map((type) => type._rawLocaleTitle[locale])
                    .join(", ")}
                  longtext={_rawLocaleTitle[locale]}
                />
              </Grid>
            </Grid>
          </ShowMobileOnly>
        </Section>
        {contentWithNavData && (
          <Container paddingBottom>
            <Grid container spacing={0} justify="center">
              <Grid item xs={12} md={8}>
                <ContentWithNav data={contentWithNavData} locale={locale} />
              </Grid>
            </Grid>
          </Container>
        )}
        {_rawRequirements && (
          <Section paddingBottom>
            <Grid container spacing={0}>
              <Grid item xs={false} md={1} />
              <Grid item xs={12} md={4}>
                <Title2>{localeData._rawRequirements[locale]}</Title2>
              </Grid>
            </Grid>
            <Vspacer marginBottom={vSpacing.baseX5}>
              <Grid container spacing={0} justify="center">
                <Grid item xs={12} md={8}>
                  <BlockText blocks={_rawRequirements[locale]} />
                </Grid>
              </Grid>
            </Vspacer>
            {_rawSpecialRequirements && (
              <Grid container spacing={0} justify="center">
                <Grid item xs={12} md={8}>
                  <GreyBackground>
                    <GreyRequirements>
                      <Grid container spacing={16}>
                        <Grid item xs={12}>
                          <BlockText blocks={_rawSpecialRequirements[locale]} />
                        </Grid>
                      </Grid>
                    </GreyRequirements>
                  </GreyBackground>
                </Grid>
              </Grid>
            )}
          </Section>
        )}

        <SvgBorderTop grey>
          <Container grey paddingTop paddingBottom>
            <StorySelection locale={locale} />
          </Container>

          {image && (
            <Container grey paddingBottom>
              <HeroFullWidthMiddle img={image} />
            </Container>
          )}

          <Container grey paddingBottom>
            <Vspacer marginBottom={vSpacing.baseX6}>
              <Grid container justify="center">
                <Grid item md={6}>
                  <Title4 center>{localeData._rawMoreVacancies[locale]}</Title4>
                </Grid>
              </Grid>
            </Vspacer>
            <Section>
              <VacancySelection locale={locale} />
            </Section>
          </Container>
        </SvgBorderTop>

        {faqCategory && (
          <SvgBorderTop>
            <Container paddingTop paddingBottom>
              <Section>
                <FaqCategory category={faqCategory} locale={locale} />
              </Section>
            </Container>
          </SvgBorderTop>
        )}
        {teamMember && (
          <SvgBorderTop grey>
            <Container grey paddingBottom>
              <Section>
                <LetsConnect data={teamMember} locale={locale} />
              </Section>
            </Container>
          </SvgBorderTop>
        )}
      </VacancyContainer>
    </>
  )
}

export default VacancyPage
